/**
 * Author: Valeria Sinnati
 * ₍^. .^₎⟆  Card/pannello: raggio 22px e bordo sottile, come nel brand book.
 *
 * In chiaro la card è bianca con il bordo Light Purple (i visual non usano
 * ombre forti), in scuro è un viola pannello sul fondo Deep Purple.
 */
import type { HTMLAttributes } from 'react'

/**
 *  /\____/\
 * > •    • <   #1
 */
export function Card({ className = '', ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={`rounded-lg border border-line bg-panel p-6 shadow-elev ${className}`}
      {...props}
    />
  )
}
